//header menu
export const menuIcon = document.querySelector('#menu-icon');
export const navMenu = document.querySelector('#nav-menu');

// calculator
export const getRange = document.querySelector('#range');
export const controlData = document.querySelector('#controls');
export const model1Km = document.querySelector('#model1Km');
export const model2Km = document.querySelector('#model2Km');
export const speed = document.querySelector('#speed');
export const temperature = document.querySelector('#temperature');
export const getClimate = document.querySelector('#climateButton');
export const getWheels = document.querySelectorAll('#wheels');
export const getSizes = document.querySelectorAll('#wheelSize');
